import styled from "styled-components";
import backArrow from "../../../assets/images/icons/arrow-left-straight.svg";
import wavyOctagon from "../../../assets/images/general/wavy-octagon.png";
import { colors, fonts } from "../../../styles/variables";
import Button from "../Button";
import breakpoints from "../../../styles/breakpoints";

interface ButtonInterface {
  ghost?: boolean;
  lg?: boolean;
  outline?: boolean;
}

export const Header = styled.div`
  text-align: center;
  position: relative;
  padding: 20px 30px;
  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const BackArrow = styled.img.attrs(() => ({
  src: backArrow,
}))`
  height: 15px;
  width: 15px;
  position: absolute;
  left: 0;
  cursor: pointer;
  margin: 0 15px;
`;

export const ChallengeDescriptionTitle = styled.h3`
  font-size: 20px;
  letter-spacing: 0.5px;
  font-family: ${fonts.fontInterstateUltraBlack};
  text-transform: uppercase;
  margin-bottom: 20px;
`;

export const ChallengeDescriptionTableImageWrapper = styled.div`
  height: 50px;
  width: 50px;
  min-width: 50px;
  margin-right: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const ChallengeBadgeImageBackground = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 50px;
  width: 50px;
  background: url("${wavyOctagon}") no-repeat 100% 100% / cover;
`;

export const ChallengeBadgeImage = styled.img`
  height: 35px;
  width: 35px;
`;

export const TextComponent = styled.div`
  flex-flow: column;
`;

export const ChallengeNameTitle = styled.div`
  text-transform: uppercase;
  font-family: ${fonts.fontInterstateUltraBlack};
  font-size: 20px;
  line-height: 24px;
  margin-bottom: 12px;
`;

export const ChallengeStartTime = styled.div`
  line-height: 20px;
  font-size: 14px;
`;

export const GameplayButton = styled(Button)<ButtonInterface>`
  text-align: left;
  width: 100%;
  border: 1px solid ${colors.silver};
  border-top: 0px;
  padding-top: 30px;
  font-size: 12px;
`;

export const QuitButton = styled(Button)<ButtonInterface>`
  display: block;
  margin: auto;
  width: 90%;
  position: absolute;
  left: 5%;
  bottom: 100px;
  ${breakpoints.smDown} {
    bottom: 200px;
  }
`;
